import { Language } from "../../interfaces/language.enum";
import { LocalizedBannerText } from "../../interfaces/banner.interface";

export const LOCALE_ORDER: Language[] = [
  Language.English,
  Language.French,
  Language.German,
  Language.Italian,
  Language.Dutch,
];

export const LOCALE_LABELS: Record<string, string> = {
  en: "🇬🇧 English",
  fr: "🇫🇷 French",
  de: "🇩🇪 German",
  it: "🇮🇹 Italian",
  nl: "🇳🇱 Dutch",
};

export function resolveLocalizedText(
  text: LocalizedBannerText | undefined,
  preferredLocale: Language
): string {
  if (!text) return "";
  return (
    text[preferredLocale] ??
    text[Language.English] ??
    Object.values(text)[0] ??
    ""
  );
}
